import { render, staticRenderFns } from "./favoriteProducts.vue?vue&type=template&id=aa8031c0"
import script from "./favoriteProducts.vue?vue&type=script&lang=js"
export * from "./favoriteProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports